import { createContext, type ReactNode, useContext, useEffect, useState } from 'react';
import { useLots } from './api/hooks';

const LOT_KEY = 'parkingpay.admin.lot';

function useSelectedLotState() {
  const lots = useLots();
  const [lotId, setLotId] = useState<string | null>(() => localStorage.getItem(LOT_KEY));

  useEffect(() => {
    const available = lots.data?.lots ?? [];
    if (available.length === 0) return;
    if (!lotId || !available.some((lot) => lot.id === lotId)) {
      setLotId(available[0]!.id);
      localStorage.setItem(LOT_KEY, available[0]!.id);
    }
  }, [lots.data, lotId]);

  return {
    lots: lots.data?.lots ?? [],
    loaded: lots.isSuccess,
    lotId,
    select: (id: string) => {
      setLotId(id);
      localStorage.setItem(LOT_KEY, id);
    },
  };
}

type SelectedLotContextValue = ReturnType<typeof useSelectedLotState>;

const SelectedLotContext = createContext<SelectedLotContextValue | null>(null);

export function SelectedLotProvider({ children }: { children: ReactNode }) {
  const value = useSelectedLotState();
  return <SelectedLotContext.Provider value={value}>{children}</SelectedLotContext.Provider>;
}

export function useSelectedLot() {
  const value = useContext(SelectedLotContext);
  if (!value) throw new Error('useSelectedLot must be used inside SelectedLotProvider');
  return value;
}
